const data = [
  { id: 1, name: "Credor" },
  { id: 2, name: "Admin" },
  { id: 3, name: "Devedora" },
  { id: 4, name: "Procurador" },
];

export default [...data];
